import React, { useState } from "react";
import { FaReact, FaNodeJs, FaPython, FaJava, FaAws } from "react-icons/fa";
import poly from "../assets/Screenshot 2025-12-24 110032.png";
import zoomogle from "../assets/Screenshot 2025-12-24 110449.png";
import readofast from "../assets/Screenshot 2025-12-24 110509.png";
import matchingbook from "../assets/Screenshot 2025-12-24 110917.png";
import sasj from "../assets/Screenshot 2025-12-24 111103.png";
import bookbasesolution from "../assets/Screenshot 2025-12-24 111834.png";
export default function Home() {
  const sliderData = [
    {
      image:
        "https://i0.wp.com/healthcheckscreening.com/wp-content/uploads/2017/11/AdobeStock_108067216.jpeg?fit=6168%2C2784&ssl=1",
      heading: "Build a Healthier Team With Us",
      subtext: "We care about your employees' well-being.",
    },
    {
      image:
        "https://www.hivedesk.com/wp-content/uploads/2025/06/Tips-for-Managing-Employee-Workloads.webp",
      heading: "Boost Your Team’s Efficiency",
      subtext: "Manage workloads with smart and insights.",
    },
    {
      image:
        "https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?cs=srgb&dl=pexels-fauxels-3184360.jpg&fm=jpg",
      heading: "People Make the Difference",
      subtext: "Your success starts with a strong team.",
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + sliderData.length) % sliderData.length);
  };
  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % sliderData.length);
  };

  const techData = [
    {
      name: "Java",
      icon: <FaJava />,
      desc: "Robust, object-oriented programming language widely used in enterprise applications.",
    },
    {
      name: "Python",
      icon: <FaPython />,
      desc: "A high-level, versatile programming language known for AI and data science.",
    },
    {
      name: "Node.js",
      icon: <FaNodeJs />,
      desc: "JavaScript runtime built on Chrome's V8 engine for scalable server-side apps.",
    },
    {
      name: "React JS",
      icon: <FaReact />,
      desc: "A JavaScript library for building fast and interactive UIs.",
    },
    {
      name: "React Native",
      icon: <FaReact />,
      desc: "A framework for building native mobile apps using React.",
    },
    {
      name: "AWS",
      icon: <FaAws />,
      desc: "Amazon Web Services provides scalable cloud infrastructure and services.",
    },
  ];

  return (
    <>
      {/* 1 section */}

      <div className="home-top">
        <div className="left-img">
          <div className="slider-wrapper">
            <div className="slider-container">
              <button className="arrow left" onClick={handlePrev}>
                &#10094;
              </button>
              <img
                key={currentIndex}
                src={sliderData[currentIndex].image}
                alt={`Slide ${currentIndex + 1}`}
                className="slider-img"
              />
              <div className="slider-overlay-content">
                <h2>{sliderData[currentIndex].heading}</h2>
                <p>{sliderData[currentIndex].subtext}</p>
                <button className="slider-btn">Learn More</button>
              </div>
              <button className="arrow right" onClick={handleNext}>
                &#10095;
              </button>
              <div className="dots">
                {sliderData.map((_, idx) => (
                  <span
                    key={idx}
                    className={`dot ${currentIndex === idx ? "active" : ""}`}
                    onClick={() => setCurrentIndex(idx)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 2 section */}

      <div className="Story-heading-wrapper">
        <div className="Story-heading" data-aos="fade-up">
          <h1>About Us</h1>
        </div>
        <div className="story-content-wrapper">
          <div className="Story" data-aos="fade-up">
            <div className="story-inside">
              <h1>Our Story</h1>
              <p>
                Inventore aliquam beatae at et id alias. Ipsa dolores amet
                <br /> consequuntur minima quia maxime autem. Quidem id sed{" "}
                <br /> ratione. Tenetur provident autem in reiciendis rerum at
                dolor.
                <br />
                Aliquam consectetur laudantium temporibus dicta minus
                <br /> dolor.
              </p>
              <div className="text-list">
                <p>Ullamco laboris nisi ut aliquip ex ea commo</p>
                <p>Duis aute irure dolor in reprehenderit in</p>
                <p>Ullamco laboris nisi ut aliquip ex eain</p>
              </div>
              <p>
                Vitae autem velit excepturi fugit. Animi ad non.
                <br /> Eligendi et non nesciunt suscipit repellendus <br />{" "}
                porro in quo eveniet. Molestias in maxime doloremque.
              </p>
            </div>
          </div>
          <div className="story-img">
            <img
              src="https://thumbs.dreamstime.com/b/group-human-resources-department-manager-reading-resume-document-employee-candidate-together-231586176.jpg"
              alt="story"
              data-aos="fade-down"
            />
          </div>
        </div>
      </div>

      {/* 3 section */}

      <div className="technology">
        <div className="tech-cards" data-aos="fade-up">
          {techData.map((tech, idx) => (
            <div key={idx} className="tech-card">
              <div className="tech-icon" title={tech.name}>
                {tech.icon}
              </div>
              <h2>{tech.name}</h2>
              <p className="tech-desc">{tech.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 4 section */}

      <div className="portfolio">
        <div className="portfolio-heading" data-aos="fade-up">
          <h1>PORTFOLIO</h1>
        </div>
        <p data-aos="fade-up">
          Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
          consectetur velit
        </p>
        <div className="portfolio-grid">
          <div className="portfolio-item">
            <img src={poly} alt="img1" />
          </div>

          <div className="portfolio-item">
            <img src={zoomogle} alt="img2" />
          </div>

          <div className="portfolio-item">
            <img src={readofast} alt="img3" />
          </div>

          <div className="portfolio-item">
            <img src={sasj} alt="img4" />
          </div>

          <div className="portfolio-item">
            <img src={bookbasesolution} alt="img5" />
          </div>

          <div className="portfolio-item">
            <img src={matchingbook} alt="img6" />
          </div>
        </div>
      </div>

      {/* 5 section */}

      <div className="client">
        <div className="client-heading" data-aos="fade-up">
          <h1>CLIENTS</h1>
        </div>
        <p data-aos="fade-down">
          Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
          consectetur velit
        </p>
        <div className="client-grid" data-aos="fade-up">
          {[
            "Bookbase Solution ",
            "Zoomogle",
            "BookYourAddress",
            "MatchingBook",
            "ReadoFast",
            "Polygro",
            "Capital Viza",
            "Treat by homeopath",
          ].map((company, idx) => (
            <div key={idx} className="client-box">
              <span className="client-name">{company}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
